var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionSplit',{staticClass:"PublicBondIssue2024 reverse",attrs:{"src":"../../assets/landing-finances/2.jpg"}},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_vm._l((_vm.$t('paragraphs')),function(paragraph,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(paragraph)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }